import axios from 'axios';
import { retryFailedApi } from './helpers';

export const apiProtocol = async ({ ref, container, created, orgId }) => {
  retryFailedApi();
  return await axios({
    method: 'post',
    url: `${process.env.VUE_APP_DOMAIN}/api/v1/turns/create`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ref,
      container,
      created,
      orgId,
    },
  });
};
